import { Navigate, useLocation, useParams } from "react-router-dom";

import { ErrorPage } from "@/components/ErrorPage/ErrorPage";
import { Loader } from "@/components/Loader/Loader";
import { ErrorPageType } from "@/enum";
import { useGetTrackerQuery } from "@/pages/Private/redux/profileTracker/profileTracker.api";

import { resolveLegacyTrackerTarget } from "./utils/resolveLegacyTrackerTarget";

export const TrackerToListRedirect = () => {
	const { id } = useParams<{ id: string }>();
	const { pathname } = useLocation();
	const trackerId = Number(id);
	const invalidId = !Number.isFinite(trackerId);
	// currentData belongs to this id; data may still belong to the previous URL while fetching.
	const {
		currentData: tracker,
		isLoading,
		error,
	} = useGetTrackerQuery(trackerId, {
		skip: invalidId,
	});

	if (invalidId || (error && "status" in error && error.status === 404)) {
		return <ErrorPage type={ErrorPageType.NotFound} />;
	}

	if (error) {
		return <ErrorPage type={ErrorPageType.ServerError} />;
	}

	if (isLoading || !tracker) {
		return <Loader />;
	}

	return <Navigate replace to={resolveLegacyTrackerTarget(pathname, tracker)} />;
};
